/* eslint-disable react/jsx-no-bind */
import { Helmet } from 'react-helmet-async';
// @mui
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Link as MuiLink, Container, Typography, IconButton } from '@mui/material';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
// hooks
import useResponsive from '../hooks/useResponsive';

// sections
import { LoginForm } from '../sections/auth/login';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');
  const navigate = useNavigate();

  function handleClick() {
    navigate(-1);
  }
  return (
    <>
      <Helmet>
        <title> Login | Easy Credit </title>
      </Helmet>

      <StyledRoot>
        {mdUp && (
          <StyledSection>
            <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
              Hola, bienvenido de Nuevo
            </Typography>
            <img src="/assets/illustrations/modelo.png" alt="login" />
          </StyledSection>
        )}

        <Container maxWidth="sm">
          <IconButton
            onClick={handleClick}
            aria-label="delete"
            sx={{
              position: 'absolute',
              width: 60,
              height: 60,
              right: 40,
            }}
          >
            <KeyboardReturnIcon />
            Atrás
          </IconButton>
          <StyledContent>
            <Typography variant="h4" gutterBottom>
              Easy Credit Colombia
            </Typography>

            <Typography variant="body2" sx={{ mb: 5 }}>
              Aún no tienes cuenta? {''}
              <MuiLink variant="subtitle2" underline="hover" component={RouterLink} to="/easy-auth/registro">
                Crear cuenta
              </MuiLink>
            </Typography>

            <LoginForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
